var app = angular.module("leonardo");

var TemplateAudit = function($scope, $rootScope, $controller, $q, TemplatesAuditService, TemplateService, FilterService) {

  $scope.changes = [];
  $scope.changesGrouped = [];
  $scope.templateExpanded = null;
  $scope.changeExpanded = null;
  $scope.has_pending_audit = false;

  $scope.templateService = TemplateService;

  $scope.changeIsExpanded = function (change) {
    return $scope.changeExpanded === change.id;
  };

  $scope.expandChange = function (change) {
    if ($scope.changeIsExpanded(change))
      $scope.changeExpanded = null;
    else
      $scope.changeExpanded = change.id;
  };

  $scope.getNameField = function(name) {
    if (!name) return '';
    var result = name.split('_').join(' ');
    return capitalize(result);
  };

  $scope.toggleTemplate = function(id) {
    if ($scope.templateExpanded === id)
      $scope.templateExpanded = null;
    else
      $scope.templateExpanded = id;
  };

  $scope.isTemplatePending = function (template) {
    var pending = false;
    angular.forEach(template.changes, function (value) {
      if ($scope.isPending(value))
        pending = true;
    });
    return pending;
  };

  $scope.isPending = function (change) {
    return (change.status === 'Pending') && change.editable;
  };

  $scope.getStatus = function (change) {
    return change.status;
  };

  $scope.templateIsExpanded = function(id) {
    return $scope.templateExpanded === id;
  };

  $scope.indexGroup = function (id) {
    var index = -1;
    angular.forEach($scope.changesGrouped, function (value, key) {
      if (value.id === id)
        index = key;
    });
    return index;
  };

  $scope.groupChanges = function () {
    $scope.changesGrouped = [];
    angular.forEach($scope.changes, function (value, key) {
      if ($scope.indexGroup(value.child_object.id) === -1)
        $scope.changesGrouped.push({id: value.child_object.id, name: value.child_object.name, changes: []});
      $scope.changesGrouped[$scope.indexGroup(value.child_object.id)].changes.push(value);
    });
  };

  $scope.accept = function (change) {
    return change.accept().then(function () {
      $scope.loadPage($scope.page);
    });
  };

  $scope.reject = function (change) {
    return change.reject().then(function () {
      $scope.loadPage($scope.page);
    });
  };

  $scope.acceptTemplate = function (template) {
    TemplateService.acceptAudit(template.id).then(function () {
      $scope.loadPage($scope.page);
    });
  };

  $scope.rejectTemplate = function (template) {
    TemplateService.rejectAudit(template.id).then(function () {
      $scope.loadPage($scope.page);
    });
  };

  $scope.getEntitiesPromise = function(options) {
    options['account'] = FilterService.getFilter('account_reports');
    options['group'] = FilterService.getFilter('group_reports');
    options['portfolio'] = FilterService.getFilter('portfolio_reports');
    options['property'] = FilterService.getFilter('property_reports');
    options['status'] = FilterService.getFilter('audit');

    var defer = $q.defer();
    TemplatesAuditService.getlist(options, true).then(function (list) {
      $scope.changes = list;
      $scope.has_pending_audit = list.meta.has_pending_audit;
      $scope.groupChanges();
      var auditIds = [];
      angular.forEach($scope.changes, function (value) {
        if (value.status === 'Pending' && value.editable) {
          auditIds.push(value.id);
        }
      });
      $rootScope.$broadcast('template-audit-list:updated', $scope.has_pending_audit, auditIds);
      defer.resolve(list);
    }, function (error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  $controller('TableFilterController', { $scope: $scope });
  $scope.loadPage(1);

  $scope.$on('template-audits:updated', function() {
    $scope.loadPage($scope.page);
  });

};

app.controller('TemplateAudit', ['$scope', '$rootScope', '$controller', '$q', 'TemplatesAuditService',
  'TemplateService', 'FilterService', TemplateAudit]);
